import { useEffect, useState } from "react";

export default function Availability() {
  const [selectedType, setSelectedType] = useState("2-person");
  const [days, setDays] = useState([]);
  const [siteData, setSiteData] = useState([]);

  const getCabinType = (site) => {
    if (["011", "012", "WF1"].includes(site)) return "2-person";
    return "4-person";
  };

  const parseHtml = async () => {
    try {
      const res = await fetch("/vacancy00all.html");
      const htmlText = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, "text/html");

      const tables = doc.querySelectorAll("table");

      // ✅ Find the correct table by content
      const table = Array.from(tables).find((t) =>
        t.innerText.includes("Site")
      );

      if (!table) {
        console.error("No valid table found");
        return;
      }

      const rows = Array.from(table.querySelectorAll("tr"));

      if (rows.length < 3) {
        console.error("Table structure invalid");
        return;
      }

      // ✅ Header row is index 1
      const headerCells = Array.from(rows[1].querySelectorAll("td"));

      const extractedDays = headerCells
        .slice(1, -1)
        .map((td) => td.innerText.replace(/\s+/g, " ").trim());

      setDays(extractedDays);

      // ✅ Parse data rows
      const data = [];

      for (let i = 2; i < rows.length - 1; i++) {
        const cells = Array.from(rows[i].querySelectorAll("td"));

        if (cells.length < 5) continue;

        const site = cells[0].innerText.trim();

        if (!site || site === "Site") continue;

        const type = getCabinType(site);

        const dayValues = cells
          .slice(1, -1)
          .map((td) => td.innerText.trim());

        data.push({
          site,
          type,
          days: dayValues,
        });
      }

      setSiteData(data);
    } catch (err) {
      console.error("Parse failed:", err);
    }
  };

  useEffect(() => {
    parseHtml();
  }, []);

  const availability =
    days.length === 0
      ? []
      : days.map((_, d) => {
          return siteData
            .filter((s) => s.type === selectedType)
            .some((s) => s.days[d] === "V")
            ? "V"
            : "R";
        });

  return (
    <div className="page">
      <h2>Cabin Availability</h2>

      <select
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
      >
        <option value="2-person">2-Person Cabin</option>
        <option value="4-person">4-Person Cabin</option>
      </select>

      <table border="1" cellPadding="5" style={{ marginTop: "20px" }}>
        <thead>
          <tr>
            <th>Type</th>
            {days.map((day, i) => (
              <th key={i}>{day}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{selectedType}</td>
            {availability.map((val, i) => (
              <td
                key={i}
                style={{
                  backgroundColor: val === "V" ? "#90ee90" : "#ffcccb",
                  textAlign: "center",
                }}
              >
                {val === "V" ? "Available" : "Full"}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}